class SampleOrder {
    constructor(couponInfo, programId, debug) {
        this.programId = programId;
        this.programType = couponInfo.programDetails.programType;
        this.isProgressive = couponInfo.programDetails.isProgressive;
        this.termsPageName = couponInfo.programDetails.termsPageName;
        this.couponCode = couponInfo.couponCode;
        this.supplierName = couponInfo.supplierName;   

	//frame for lab supplied
	if (couponInfo.programDetails.jobType === "PICK" ||
           couponInfo.programDetails.jobType === "TPB" ||
           couponInfo.programDetails.jobType === "REP" ||
           couponInfo.programDetails.jobType === "LUX")
        {
            this.isLabSuppliedFrame = true;
        }
        else
        {
            this.isLabSuppliedFrame = false;
        }

        this.uncut = false;
      
        //shipping
        this.name = couponInfo.name;
        this.addressLine1 = couponInfo.address1;
        this.addressLine2 = couponInfo.address2;
        this.city = couponInfo.city;
        this.region = couponInfo.region;
        this.postalCode = couponInfo.postalCode;
        this.phone = couponInfo.phone;
        this.email = couponInfo.email;

        //frame for FTC
        this.manufacturer = "";
        this.model = "";
        this.color = "";
        this.type = "";
        this.aBox = "";
        this.bBox = "";
        this.templeLength = "";
        this.dbl = "";

        //frame for lab supplied
        this.labSuppliedFrame = null;

        //RX
        this.firstName = "";
        this.lastName = "";
        this.currentLens = "";
        this.practiceName = "";
        this.role = "";
        this.freeEntry1 = "";
        this.freeEntry2 = "";
        this.freeEntry3 = "";
        this.freeEntry4 = "";
        this.freeEntry5 = "";


        //RX OD
        this.resph = null;
        this.recyl = null;
        this.reaxis = null;
        this.readd = null;
        this.rehorizPrismValue = null;
        this.rehorizPrismDirection = null;
        this.reverticalPrismValue = null;
        this.reverticalPrismDirection = null;
        this.redistPD = null;
        this.resegHeight = null;

        //RX OS
        this.lesph = null;
        this.lecyl = null;
        this.leaxis = null;
        this.leadd = null;
        this.lehorizPrismValue = null;
        this.lehorizPrismDirection = null;
        this.leverticalPrismValue = null;
        this.leverticalPrismDirection = null;
        this.ledistPD = null;
        this.lesegHeight = null;
        this.acceptedTerms = false;
        this.treatment = null;
        this.material = null;
        this.design = null;
        this.photochromic = null;

        if (false) {
            this.name = "ship name";
            this.addressLine1 = "ship add 1";
            this.addressLine2 = "ship add 2";
            this.city = "ship city";
            this.region = "ship state";
            this.postalCode = "76208";
            this.phone = "940-123-1234";
            this.email = "foo@bar.com";

            //frame
            this.manufacturer = "Test Manu";
            this.model = "Test Model";
            this.color = "Test Color";
            this.type = "DRILL2";
            this.aBox = "20";
            this.bBox = "30";
            this.templeLength = "40";
            this.dbl = "25";

            //RX
            this.firstName = "Test";
            this.lastName = "User";
            this.practiceName = "Practice name";
            this.currentLens = "Current lens";
            this.role = "my role";

            //RX OD
            this.resph = 1.25;
            this.recyl = null;
            this.reaxis = null;

            this.redistPD = 30;
            this.resegHeight = 30;

            //RX OS
            this.lesph = 1.25;
            this.lecyl = null;
            this.leaxis = null;

            this.ledistPD = 30;
            this.lesegHeight = 30;
            this.acceptedTerms = false;
        }
    }
}

export default SampleOrder;
